export function retryDelay(attemptIndex: number) {
    return Math.min(1000 * Math.pow(2, attemptIndex), 30000);
}